// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NADa8GkgsJ5T_j {
  margin-left: var(--ds-space-075, 6px);
}
.NADa8GkgsJ5T_j span {
  font-weight: var(--ds-font-weight-regular, 400);
  text-transform: none;
}
`, ""]);
// Exports
export var newTag = `NADa8GkgsJ5T_j`;
export default ___CSS_LOADER_EXPORT___;
